import { isExperienceItem } from 'lib/checkout/checkoutUtils'

/**
 * Free extras (Experiences Passport, shown as "LE Exclusive Extras") ride with their room: they're $0,
 * so svc-payment never splits them, and svc-order cancels them with the room.
 */
export function isGroupPaymentFreeExtraCartItem(item: App.Checkout.AnyItem, roomItemIds: Set<string>): boolean {
  return isExperienceItem(item) &&
    !!item.experiencesPassport &&
    !!item.accommodationParentItemId &&
    roomItemIds.has(item.accommodationParentItemId) &&
    item.tickets.every(ticket => ticket.price === 0)
}
